export default __webpack_public_path__ + "static/media/google.9db27c10.png";